import moment from 'moment';

export const getSemester = (): string => {
  const day = moment().dayOfYear();
  const fallStart = moment('2000-08-01').dayOfYear();
  const summerStart = moment('2000-06-01').dayOfYear();

  if (day >= fallStart) {
    return 'fall';
  }
  if (day >= summerStart) {
    return 'summer';
  }
  return 'spring';
};

export const getBeforeAfterDueDateDue = (dueDate: string): string => {

  if (!dueDate) {
    return '';
  }

  const dateFormat = 'YYYY-MM-DD';
  const dateString = moment(dueDate).format(dateFormat);

  const diff = moment(new Date()).diff(dueDate);
  const days = moment.duration(diff).days();

  if (diff < 0 && days === 0) {
    return dateString;
  }

  if (days > 0) return `${dateString} +${days}`;
  return `${dateString} ${days}`;
};
